import { Component, EventEmitter, Input } from '@angular/core';
import { get, defaultTo, cloneDeep } from 'lodash-es';

import { User, ListProperty, ListExpirySubscription } from '@site-mate/dashpivot-shared-library';

import { AbstractListHeader } from 'app/lists/abstract-list-header/abstract-list-header.component';
import { ToastrService } from 'app/shared/service/toastr.service';

@Component({
  templateUrl: './list-header-date-expiry.component.html',
  styleUrls: [
    '../abstract-list-header/abstract-list-header.component.scss',
    './list-header-date-expiry.component.scss',
  ],
  selector: 'cc-list-header-date-expiry',
})
export class ListHeaderDateExpiryComponent extends AbstractListHeader {
  @Input() currentUser: User;
  @Input() editable = true;

  private readonly expiryMenuClosed = new EventEmitter<void>();

  constructor(private readonly toastrService: ToastrService) {
    super();
  }

  isPropertySubscribed() {
    const subscribedUsers = get(this.property, 'subscribedUsers', {
      userIds: [],
      notificationPeriods: [],
    }) as ListProperty['subscribedUsers'];
    const userIds = defaultTo(subscribedUsers.userIds, []);
    return userIds.includes(this.currentUser.id);
  }

  onSubscribeDateExpiration(subscription: ListExpirySubscription) {
    const property = cloneDeep(this.property);
    let { userIds, notificationPeriods } = subscription;

    if (!notificationPeriods.length) {
      userIds = [];
    }

    if (!userIds.length) {
      notificationPeriods = [];
    }

    property.subscribedUsers = { userIds, notificationPeriods };

    this.propertyChanged.emit(property);
    this.toastrService.successByKey('listExpiryDateNotificationUpdated');
  }

  onMenuChange(opened: boolean) {
    if (!opened) {
      this.expiryMenuClosed.emit();
    }
  }
}
